// ── ADMIN actions ──────────────────────────────────────
export const CREATE_CATEGORY         = 'CREATE_CATEGORY';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CREATE_CATEGORY_FAILURE = 'CREATE_CATEGORY_FAILURE';

export const UPDATE_CATEGORY         = 'UPDATE_CATEGORY';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAILURE = 'UPDATE_CATEGORY_FAILURE';

export const GET_CATEGORY            = 'GET_CATEGORY';
export const GET_CATEGORY_SUCCESS    = 'GET_CATEGORY_SUCCESS';
export const GET_CATEGORY_FAILURE    = 'GET_CATEGORY_FAILURE';

export const DELETE_CATEGORY         = 'DELETE_CATEGORY';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE';

// ── FRONTEND action (navbar mega menu) ────────────────
export const FETCH_CATEGORY         = 'FETCH_CATEGORY';
export const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS';
export const FETCH_CATEGORY_FAILURE = 'FETCH_CATEGORY_FAILURE';